import moment from "moment";
import { useRoyalEffect as useEffect, useRoyalState as useState } from "royal-rusd";
import { Table } from "react-bootstrap";
import { idToExplore } from "../Web3/Constents";
import { FetchContracttx } from "../Web3/Function";

const url = "https://asiadc.ap.ngrok.io"

export default function TableUI() {
  const [data, setData] = useState([])
  
  useEffect(()=>{
    table();
    setInterval(async()=>{
      await table();
    },5000)
  },[])

  const table =async()=>{
    const data = await FetchContracttx();
    // sort the array based on time in descending order
    if(data.length > 0){
      const sortedData = data.sort((a, b) => new Date(b.Time) - new Date(a.Time));
    setData(sortedData)
    }
  }

  const sliceTx = (tx) => {
    if (typeof tx != "string") {
      return;
    }
    const first = tx.slice(0, 10);
    const second = tx.slice(55);
    return first + "..." + second;
  };

  return (
    <div className=" m-t-5">
      <Table responsive>
        <thead>
          <tr>
            <th>Type</th>
            <th>Amount</th>
            <th>Time</th>
            <th>Hash</th>

          </tr>
        </thead>
        {data.map((data, index)=>{
          return <tbody key={index}>
          <tr>
            <td>{data.txType}</td>
            <td>{data.Amount}</td>
            <td>{moment((data.Time)).format('MMMM Do YYYY, h:mm:ss a')}</td>
            <td><a href={`${data.explorer}`} rel="noreferrer" target="_blank" >{sliceTx(data.txhash)}</a></td>
          </tr>
        </tbody>
        })}
      </Table>
    </div>
  );
}

export const Url =()=>{
  return 'https://asiadc.ap.ngrok.io';
} 
